/* CELOPMAN — Regalo automático: PERFUME ICELAND gratis con 80€ (25-27 sep 2026).
   Añade 1 perfume al superar el umbral y lo retira si baja o fuera de fechas.
   Red de seguridad: si por lo que sea no queda a 0€, retira el que añadimos y deja de intentarlo. */
(function () {
  var GIFT_VARIANT = 54906978861321;      // PERFUME ISLAND ACCORD - U (ref 200999)
  var THRESHOLD = 8000;                     // 80,00 € en céntimos (items que cuentan, sin el regalo)
  var START = Date.parse('2026-09-28T00:00:00+02:00');
  var END   = Date.parse('2026-09-28T23:59:59+02:00');

  function inWindow() { var n = Date.now(); return n >= START && n <= END; }

  var busy = false, timer = null, addedByUs = false, giftFailed = false;

  function getCart() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }
  function addGift() { return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: GIFT_VARIANT, quantity: 1 }] }) }); }
  function setGift(q) { return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: String(GIFT_VARIANT), quantity: q }) }); }

  function done(changed) { busy = false; if (changed) refreshUI(); }

  function evaluate() {
    if (busy) return; busy = true;
    getCart().then(function (cart) {
      var gift = null, qualifying = 0;
      (cart.items || []).forEach(function (i) {
        if (i.variant_id === GIFT_VARIANT) gift = i;
        else qualifying += i.final_line_price;
      });
      var qualifies = inWindow() && qualifying >= THRESHOLD;

      if (qualifies) {
        if (!gift) {
          if (giftFailed) return done(false);
          return addGift().then(function () { addedByUs = true; toast(); done(true); }).catch(function () { done(false); });
        }
        if (gift.quantity > 1) return setGift(1).then(function () { done(true); }).catch(function () { done(false); });
        if (gift.final_line_price > 0) {                 // no salió gratis
          if (addedByUs) { giftFailed = true; return setGift(0).then(function () { done(true); }).catch(function () { done(false); }); }
          return done(false);                            // lo puso el cliente a mano: no tocar
        }
        return done(false);                              // presente y gratis: ok
      } else {
        if (gift && (addedByUs || gift.final_line_price === 0)) return setGift(0).then(function () { done(true); }).catch(function () { done(false); });
        return done(false);
      }
    }).catch(function () { busy = false; });
  }

  function schedule() { clearTimeout(timer); timer = setTimeout(evaluate, 400); }

  function refreshUI() {
    ['cart:refresh', 'cart:build', 'cart:updated'].forEach(function (n) { try { document.dispatchEvent(new CustomEvent(n, { bubbles: true })); } catch (e) {} });
    try { if (window.Shopify && typeof Shopify.onCartUpdate === 'function') Shopify.onCartUpdate(); } catch (e) {}
  }

  function toast() {
    if (document.getElementById('gift80Toast')) return;
    var t = document.createElement('div');
    t.id = 'gift80Toast';
    t.textContent = 'Regalo añadido: tu PERFUME ISLAND ACCORD gratis está en la cesta';
    t.style.cssText = 'position:fixed;left:50%;bottom:26px;transform:translateX(-50%);z-index:99999;background:#0a0a0a;color:#fff;font:500 13px/1.4 Inter,system-ui,sans-serif;letter-spacing:.02em;padding:14px 20px;box-shadow:0 12px 40px rgba(0,0,0,.35);max-width:90vw;text-align:center;opacity:0;transition:opacity .35s ease';
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.style.opacity = '1'; });
    setTimeout(function () { t.style.opacity = '0'; setTimeout(function () { t.remove(); }, 400); }, 4200);
  }

  // Detectar mutaciones del carrito (fetch)
  var of = window.fetch;
  window.fetch = function () {
    var a = arguments, url = (a[0] && a[0].url) || a[0] || '';
    var p = of.apply(this, a);
    try { if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url) && !busy) p.then(function () { schedule(); }); } catch (e) {}
    return p;
  };
  // Detectar mutaciones del carrito (XHR)
  var ox = XMLHttpRequest.prototype.open, os = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) { this.__cartMut = /\/cart\/(add|change|update|clear)/.test(u || ''); return ox.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () { if (this.__cartMut) { var self = this; this.addEventListener('load', function () { if (!busy) schedule(); }); } return os.apply(this, arguments); };

  if (inWindow()) {
    if (document.readyState !== 'loading') evaluate();
    else document.addEventListener('DOMContentLoaded', evaluate);
  }
})();
